import { ICustomViewColumn } from './custom-view-column';
import { CustomViewDisplayLayout } from './custom-view-display-layout';
import { ViewContext } from './view-context';

export class CustomView implements ICustomView {
  public id: string;
  public viewContext: ViewContext;
  public auth0UserId: string;
  public name: string;
  public filters: string[];
  public quickFilterNames: string[];
  public isPublic: boolean;
  public isSystemView: boolean;
  public isTemporary: boolean;
  public isModified: boolean;
  public isSelected: boolean;
  public isDefault: boolean = false;
  public columns: ICustomViewColumn[] = [];
  public orginalColumns: ICustomViewColumn[] = [];
  public customViewDisplayLayout?: CustomViewDisplayLayout;
  public originalDisplayLayout?: CustomViewDisplayLayout;
  public viewContextId?: string;

  constructor(data: ICustomView, isSystemView = false, isTemporary = false) {
    this.id = data.id;
    this.viewContext = data.viewContext;
    this.auth0UserId = data.auth0UserId;
    this.name = data.name;
    this.filters = data.filters.slice();
    this.quickFilterNames = data.quickFilterNames;
    this.isPublic = data.isPublic;
    this.columns = data.columns;
    this.orginalColumns = data.columns.slice();
    this.isSystemView = isSystemView;
    this.customViewDisplayLayout = data.customViewDisplayLayout;
    this.originalDisplayLayout = data.customViewDisplayLayout;
    this.isTemporary = isTemporary;
    this.viewContextId = data.viewContextId;
  }

  get headerName(): string {
    return this.isModified ? `${this.name} *` : this.name;
  }

  reset() {
    this.isModified = false;
    this.columns = [...this.orginalColumns];
    this.customViewDisplayLayout = this.originalDisplayLayout;
  }
}

export interface ICustomView {
  id: string;
  viewContext: ViewContext;
  name: string;
  filters: string[];
  quickFilterNames: string[];
  isPublic: boolean;
  auth0UserId?: string;
  columns: ICustomViewColumn[];
  customViewDisplayLayout?: CustomViewDisplayLayout;
  viewContextId?: string;
}
